import React from 'react';
import Dashboard from './components/Dashboard';
import TokenGuard from './components/auth/TokenGuard';

function App() {
  return (
    <TokenGuard>
      <div className="App">
        <Dashboard />
      </div>
    </TokenGuard>
  );
}

export default App; 